"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pager = void 0;
class Pager {
    eventBus;
    enabled;
    pageSize;
    totalSize;
    totalPages;
    currentPage;
    constructor(options) {
        this.eventBus = options.eventBus;
        this.enabled = options.enabled || false;
        this.totalSize = options.totalSize;
        this.pageSize = options.pageSize;
        this.recalculate(1);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    setTotalSize(size) {
        this.totalSize = size;
        this.recalculate(this.currentPage ? this.currentPage.number : 1);
    }
    setPageSize(size) {
        this.pageSize = size;
        this.recalculate(this.currentPage ? this.currentPage.number : 1);
    }
    setCurrentPage(pageNumber) {
        this.recalculate(pageNumber);
    }
    currentPageSlice(rows) {
        const startIndex = (this.currentPage.number - 1) * this.pageSize;
        return rows.slice(startIndex, startIndex + this.pageSize);
    }
    recalculate(pageNumber) {
        this.totalPages = Math.ceil(this.totalSize / this.pageSize);
        const startPos = this.pageSize * (pageNumber - 1) + 1;
        const endPos = Math.min(startPos + this.pageSize, this.totalSize);
        this.currentPage = { number: pageNumber, startPos, endPos };
        this.eventBus.$emit('updateView', { trigger: 'recalculate' });
    }
}
exports.Pager = Pager;
//# sourceMappingURL=pager.js.map